import { createSelector } from '@ngrx/store';
import { getManagementState, ManagementState } from '../management.reducer';
import {asyncActionState} from '@emm/core/util/async-action-state';

const getState = createSelector(
    getManagementState,
    (state: ManagementState) => state.itemGroupings
);

const asyncActionStateSelectors = asyncActionState.getSelectors(getState);

export const ItemGroupingsSelectors = {
    ...asyncActionStateSelectors
};
